import type { Ref } from 'vue';

/**
 * Decides whether the inertiaui-modal `<Modal>` may be rendered.
 *
 * Named (local) modals build their own context internally and must always render so they can
 * register with the modal stack. Unnamed (route) modals rely on an injected `modalContext`; when
 * that context — or its current value — is absent (the modal page is rendered outside the modal
 * stack, or is being torn down after the stack was cleared) rendering the inner Modal dereferences
 * an undefined context and crashes with "undefined is not an object (evaluating '...shouldRender')".
 */
export function canRenderModal(name: string | null | undefined, modalContext: Ref<unknown> | null | undefined): boolean {
    if (name) {
        return true;
    }

    return modalContext?.value != null;
}
